var _path, _path2, _path3, _rect, _rect2, _path4, _g, _rect3, _rect4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotebooks = function SvgNotebooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237,
    height: 174,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14141C",
    stroke: "#fff",
    strokeOpacity: 0.4,
    d: "M0 0h135.659v142.806H0z",
    transform: "matrix(.8403 .54212 -.8403 .54212 122.049 13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#16161C",
    stroke: "#fff",
    strokeOpacity: 0.4,
    d: "M0 0h135.66v9.193H0z",
    transform: "matrix(.84028 .54215 0 1 2.049 90.421)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#343449",
    stroke: "#fff",
    strokeOpacity: 0.2,
    d: "M0 0h142.816v9.193H0z",
    transform: "matrix(.84028 -.54215 0 1 116.041 163.968)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 139.743,
    height: 80.458,
    fill: "#14141C",
    rx: 2,
    transform: "matrix(.8349 -.55039 .8349 .55039 .549 76.913)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 139.243,
    height: 79.958,
    x: 0.417,
    stroke: "#FBF9F9",
    strokeOpacity: 0.7,
    strokeWidth: 0.5,
    rx: 1.75,
    transform: "matrix(.8349 -.55039 .8349 .55039 .618 77.143)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "notebooks_svg__b",
    width: 118,
    height: 78,
    x: 51,
    y: 32,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__a)",
    d: "M0 0h117.32v22.867H0z",
    transform: "scale(1.18074 .77837)rotate(-45 172.742 9.857)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#notebooks_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__c)",
    fillOpacity: 0.2,
    d: "M52.345 97.873c-.461-.304-.461-.797 0-1.1L149.46 32.75l19.092 12.586-97.951 64.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__d)",
    fillOpacity: 0.2,
    d: "M52.345 97.873c-.461-.304-.461-.797 0-1.1l8.831-5.823 19.092 12.586-9.666 6.372z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__e)",
    fillOpacity: 0.2,
    d: "M58.71 100.968c-.461.304-1.209.304-1.67 0l-5.529-3.645 97.951-64.572 6.364 4.195z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0-.25h22.867",
    transform: "matrix(.8349 .55039 -.8349 .55039 61.39 91.09)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0-.25h22.867",
    transform: "scale(1.18074 .77837)rotate(45 -88.299 132.445)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0-.25h22.867",
    transform: "scale(1.18074 .77837)rotate(45 -54.732 146.35)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0-.25h22.867",
    transform: "scale(1.18074 .77837)rotate(45 -21.166 160.253)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0-.25h117.399",
    transform: "scale(-1.18074 -.77837)rotate(-45 -123.27 135.564)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0-.25h117.399",
    transform: "scale(-1.18074 -.77837)rotate(-45 -132.64 139.443)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.255,
    d: "M0-.127h117.399",
    transform: "matrix(-.8349 .55039 -.8349 -.55039 177.068 50.95)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.255,
    d: "M0-.127h117.399",
    transform: "scale(-1.18074 -.77837)rotate(-45 -163.9 152.395)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.255,
    d: "M0-.127h117.399",
    transform: "matrix(-.8349 .55039 -.8349 -.55039 190.768 59.98)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.255,
    d: "M0-.127h117.399",
    transform: "scale(-1.18074 -.77837)rotate(-45 -183.704 160.598)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.255,
    d: "M0-.127h117.399",
    transform: "matrix(-.8349 .55039 -.8349 -.55039 204.465 69.01)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.255,
    d: "M0-.127h117.399",
    transform: "scale(-1.18074 -.77837)rotate(-45 -203.507 168.8)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.255,
    d: "M0-.127h117.399",
    transform: "scale(-1.18074 -.77837)rotate(-45 -213.41 172.903)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.255,
    d: "M0-.127h117.399",
    transform: "matrix(-.8349 .55039 -.8349 -.55039 225.01 82.555)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.255,
    d: "M0-.127h117.399",
    transform: "matrix(-.8349 .55039 -.8349 -.55039 231.859 87.07)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 139.743,
    height: 54.203,
    fill: "#14141C",
    rx: 2,
    transform: "scale(1.18074 .77837)rotate(-45 220.722 6.922)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 139.243,
    height: 53.703,
    x: 0.417,
    stroke: "#FBF9F9",
    strokeOpacity: 0.7,
    strokeWidth: 0.5,
    rx: 1.75,
    transform: "scale(1.18074 .77837)rotate(-45 221.108 7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__f)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.28v29.867H0z",
    transform: "scale(-1.18074 .77837)rotate(45 -230.727 -24.855)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__g)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.373v36.47H0z",
    transform: "scale(-1.18074 .77837)rotate(45 -201.15 -73.723)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__h)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.373v39.5H0z",
    transform: "scale(-1.18074 .77837)rotate(45 -208.266 -46.198)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__i)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.373v36.47H0z",
    transform: "scale(-1.18074 .77837)rotate(45 -217.31 -34.707)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__j)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.373v32.227H0z",
    transform: "scale(-1.18074 .77837)rotate(45 -211.656 -62.843)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__k)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.28v29.867H0z",
    transform: "scale(-1.18074 .77837)rotate(45 -203.641 -90.395)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__l)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.373v36.47H0z",
    transform: "matrix(-.8349 .55039 .8349 .55039 176.468 64.054)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__m)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.373v39.5H0z",
    transform: "scale(-1.18074 .77837)rotate(45 -181.18 -111.738)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__n)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.373v36.47H0z",
    transform: "matrix(-.8349 .55039 .8349 .55039 149.481 81.844)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__o)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.373v32.227H0z",
    transform: "scale(-1.18074 .77837)rotate(45 -184.57 -128.38)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__p)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .275h8.816v28.296H0z",
    transform: "matrix(-.8349 .55039 .8349 .55039 191.862 62.64)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__q)",
    fillOpacity: 0.5,
    d: "m116.119 131.316-7.33 4.832 10.008 6.597 7.33-4.832z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__r)",
    fillOpacity: 0.5,
    d: "m142.984 101.452-7.408 4.884 19.228 12.676 7.409-4.884z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__s)",
    fillOpacity: 0.5,
    d: "m127.018 114.646-7.409 4.884 17.204 11.341 7.409-4.884z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__t)",
    fillOpacity: 0.5,
    d: "m113.973 117.907-7.409 4.884 21.253 14.01 7.408-4.884z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__u)",
    fillOpacity: 0.5,
    d: "m141.074 112.05-7.408 4.884 12.144 8.006 7.408-4.884z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__v)",
    fillOpacity: 0.5,
    d: "m156.799 98.388-7.33 4.832 14.678 9.676 7.33-4.832z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__w)",
    fillOpacity: 0.5,
    d: "m164.115 79.49-7.33 4.832 25.354 16.713 7.33-4.832z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__x)",
    fillOpacity: 0.5,
    d: "m168.131 94.437-6.664 4.393 12.01 7.917 6.663-4.393z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__y)",
    fillOpacity: 0.5,
    d: "m180.785 79.057-6.664 4.393 17.347 11.435 6.664-4.392z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__z)",
    fillOpacity: 0.5,
    d: "m186.076 70.244-7.33 4.833 21.35 14.074 7.331-4.832z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__A)",
    fillOpacity: 0.5,
    d: "m200.111 68.076-7.33 4.832 16.013 10.556 7.33-4.832z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "m22.549 78.599 12.27-8.089 2.265 1.494-12.27 8.088zM38.557 68.047l21.09-13.903 2.265 1.493-21.09 13.903zM63.383 51.68l4.09-2.696 2.265 1.493-4.09 2.696zM71.21 46.52l18.687-12.318 2.265 1.493-18.686 12.318zM93.633 31.739l4.09-2.697 2.265 1.493-4.09 2.697zM101.461 26.578l17.938-11.825 2.265 1.493-17.938 11.826zM33.82 79.131l6.135-4.044 2.265 1.493-6.135 4.044zM43.691 72.623l4.09-2.696 2.266 1.493-4.09 2.697zM51.52 67.463l10.224-6.74 2.265 1.493-10.225 6.74zM65.48 58.26l4.09-2.696 2.266 1.493-4.09 2.696zM73.309 53.1l26.16-17.245 2.265 1.493-26.16 17.245zM103.205 33.39l4.09-2.695 2.265 1.493-4.09 2.696zM111.033 28.23l10.464-6.897 2.265 1.493-10.464 6.898zM34.627 86.562l12.27-8.089 2.265 1.493-12.27 8.089zM50.635 76.009l4.09-2.696 2.265 1.493-4.09 2.696zM58.46 70.849 82.38 55.082l2.265 1.493-23.918 15.767zM86.117 52.618l4.09-2.696 2.266 1.493-4.09 2.697zM93.943 47.46l4.09-2.697 2.266 1.493-4.09 2.696zM101.771 42.3l10.225-6.741 2.265 1.493-10.225 6.74zM115.732 33.095l4.09-2.696 2.265 1.493-4.09 2.696zM123.561 27.935l8.221-5.42 2.265 1.493-8.22 5.42z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notebooks_svg__B)",
    fillOpacity: 0.4,
    d: "M0 0h116.379v3.617H0z",
    transform: "scale(1.18074 .77837)rotate(-45 157.635 16.587)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__a",
    x1: 58.66,
    x2: 58.66,
    y1: 0,
    y2: 25.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14141C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14141C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__c",
    x1: 61.056,
    x2: 120.4,
    y1: 103.616,
    y2: 13.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__d",
    x1: 56.45,
    x2: 68.017,
    y1: 94.066,
    y2: 111.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__e",
    x1: 54.622,
    x2: 113.967,
    y1: 99.374,
    y2: 9.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__f",
    x1: 6.107,
    x2: 6.107,
    y1: 16.725,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__g",
    x1: 6.172,
    x2: 6.172,
    y1: 20.361,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__h",
    x1: 6.172,
    x2: 6.172,
    y1: 22.03,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__i",
    x1: 6.172,
    x2: 6.172,
    y1: 20.361,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__j",
    x1: 6.172,
    x2: 6.172,
    y1: 18.025,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__k",
    x1: 6.107,
    x2: 6.107,
    y1: 16.725,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__l",
    x1: 6.172,
    x2: 6.172,
    y1: 20.361,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__m",
    x1: 6.172,
    x2: 6.172,
    y1: 22.03,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__n",
    x1: 6.172,
    x2: 6.172,
    y1: 20.361,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__o",
    x1: 6.172,
    x2: 6.172,
    y1: 18.025,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__p",
    x1: 6.48,
    x2: 6.48,
    y1: 15.859,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__q",
    x1: 112.373,
    x2: 118.268,
    y1: 133.785,
    y2: 142.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__r",
    x1: 139.198,
    x2: 150.525,
    y1: 103.949,
    y2: 121.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__s",
    x1: 123.231,
    x2: 133.365,
    y1: 117.142,
    y2: 132.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__t",
    x1: 110.186,
    x2: 122.705,
    y1: 120.404,
    y2: 139.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__u",
    x1: 137.288,
    x2: 144.441,
    y1: 114.546,
    y2: 125.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__v",
    x1: 153.052,
    x2: 161.699,
    y1: 100.858,
    y2: 113.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__w",
    x1: 160.369,
    x2: 175.303,
    y1: 81.959,
    y2: 104.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__x",
    x1: 164.725,
    x2: 171.799,
    y1: 96.682,
    y2: 107.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__y",
    x1: 177.379,
    x2: 187.598,
    y1: 81.302,
    y2: 96.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__z",
    x1: 182.33,
    x2: 194.906,
    y1: 72.714,
    y2: 91.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__A",
    x1: 196.365,
    x2: 205.797,
    y1: 70.545,
    y2: 84.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notebooks_svg__B",
    x1: 0,
    x2: 116.379,
    y1: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB198"
  })))));
};
export { SvgNotebooks as ReactComponent };
export default __webpack_public_path__ + "static/notebooks.c8d9b6f4.svg";